import moment from "moment";
import React, { useState } from "react";
import Card from "react-bootstrap/Card";
import {
  getFieldDate,
  getFieldName,
  getFieldText,
} from "../scripts/helperScripts";
import AddEncounter from "./buttons/AddEncounter";
import AddIncidentReport from "./buttons/AddIncidentReport";
import AddSoarCorrespondence from "./buttons/AddSoarCorrespondence";
import ScrollToTop from "./buttons/ScrollToTop";
import CareTeamCard from "./common/CareTeamCard";
import DiagnosisCard from "./common/DiagnosisCard";
import EncounterCard from "./common/EncounterCard";
import IncidentCard from "./common/IncidentCard";
import Input from "./common/Input";
import RecordedServiceCard from "./common/RecordedServiceCard";
import SearchBox from "./common/SearchBox";
import SOARCorrespondenceCard from "./common/SOARCorrespondenceCard";

function DocumentationTimeline({
  timeline,
  careTeam,
  diagnosis,
  incidents,
  correspondence,
  recordedServices,
  encounters,
  progressNotes,
  contact,
  selectedProgram,
}) {
  const [searchQuery, setSearchQuery] = useState("");
  const [beginDate, setBeginDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [addNewOpen, setAddNewOpen] = useState(false);
  // const [showScroll, setShowScroll] = useState(true);
  // const checkScrollTop = () => {
  //   if (!showScroll && window.pageYOffset > 200) {
  //     setShowScroll(true);
  //   } else if (showScroll && window.pageYOffset <= 200) {
  //     setShowScroll(false);
  //   }
  // };
  // window.addEventListener("scroll", checkScrollTop);

  // const scrollTop = () => {
  //   window.scrollTo({ top: 0, behavior: "smooth" });
  // };

  const timelineSearch = ({ currentTarget: input }) => {
    setSearchQuery(input.value);
  };

  const handleBeginDate = ({ currentTarget: input }) => {
    setBeginDate(input.value);
  };

  const handleEndDate = ({ currentTarget: input }) => {
    setEndDate(input.value);
  };

  const filterHistory = () => {
    let filtered = timeline;
    filtered = filtered.filter(
      (item) =>
        item.clientprogram === undefined ||
        getFieldText(item.clientprogram) ===
          selectedProgram.ccx_client_programid
    );

    if (searchQuery) {
      filtered = filtered.filter(
        (item) =>
          (item.name &&
            item["name"].toLowerCase().includes(searchQuery.toLowerCase())) ||
          (item.type &&
            item["type"].toLowerCase().includes(searchQuery.toLowerCase()))
      );
    }

    if (beginDate !== "") {
      filtered = filtered.filter(
        (item) => new Date(getFieldDate(item.effdate)) >= new Date(beginDate)
      );
    }

    if (endDate !== "") {
      let end = new Date(endDate);
      end = end.setDate(end.getDate() + 1);
      filtered = filtered.filter(
        (item) => new Date(getFieldDate(item.effdate)) <= end
      );
    }

    // IF Begin Date
    // IF End Date

    console.log("Filtered", JSON.stringify(filtered));
    return filtered;
  };

  return (
    <>
      <div className="floating-toolbox">
        <ScrollToTop />
      </div>
      {/* <i
        className={"fas fa-arrow-circle-up fa-3x scrollTop text-safy-success"}
        onClick={scrollTop}
        style={{ height: 40, display: showScroll ? "flex" : "none" }}
      /> */}
      <div className="row mb-2">
        <div className="col-6">
          <SearchBox
            label="Search Timeline by Record Name or Type"
            value={searchQuery}
            onChange={timelineSearch}
            clearSearch={() => setSearchQuery("")}
          />
        </div>
        <div className="col-3">
          <Input
            name="beginDate"
            type="date"
            label="Begin Date"
            value={beginDate}
            onChange={handleBeginDate}
          />
        </div>
        <div className="col-3">
          <Input
            name="endDate"
            type="date"
            label="End Date"
            value={endDate}
            onChange={handleEndDate}
          />
        </div>
      </div>
      <div>
        {addNewOpen ? (
          <div>
            <i
              className={"fas fa-times-circle fa-2x"}
              style={addNewOpen ? { color: "red" } : { color: "#17a2b8" }}
              onClick={() => setAddNewOpen(!addNewOpen)}
              aria-controls="addnew-collapse-text"
              aria-expanded={addNewOpen}
            />
            <span className="h4 ms-2">Close</span>
          </div>
        ) : (
          <div>
            <i
              className={"fas fa-plus-circle fa-2x"}
              style={addNewOpen ? { color: "red" } : { color: "#17a2b8" }}
              onClick={() => setAddNewOpen(!addNewOpen)}
              aria-controls="addnew-collapse-text"
              aria-expanded={addNewOpen}
            />
            <span className="h4 ms-2">Add New</span>
          </div>
        )}

        {addNewOpen === true && (
          <div id="addnew-collapse-text" className="pt-2">
            {selectedProgram !== undefined &&
            !getFieldName(contact.owner)?.includes("South Carolina") &&
            !getFieldName(contact.owner)?.includes("Indiana") &&
            moment().isBefore(moment("2024-08-21")) ? (
              <AddIncidentReport contactID={contact.contactid} />
            ) : null}
            <AddSoarCorrespondence contact={contact} />
            {selectedProgram !== undefined ? (
              <AddEncounter contactID={contact.contactid} />
            ) : null}
          </div>
        )}
      </div>
      {timeline &&
        filterHistory()
          .sort(
            (a, b) =>
              new Date(getFieldDate(b.effdate)) -
              new Date(getFieldDate(a.effdate))
          )
          .map((item) => {
            switch (item.type) {
              case "Button":
                return (
                  <button className="m-2" key={item.name}>
                    {item.name}
                  </button>
                );

              /* #region old timeline records */
              //   case "Address":
              //     const address = addresses.filter(
              //       (a) => a.ccx_contactaddressid === item.id
              //     )[0];
              //     return (
              //       <div
              //         className="p-2"
              //         key={`tl-${address.ccx_contactaddressid}`}
              //       >
              //         Address
              //         <Card>
              //           <Card.Header
              //             className="p-0 ps-2 bg-safy1-1"
              //             style={{
              //               color: "white",
              //             }}
              //           >
              //             <div className="row">
              //               <div className="col-10 ps-4 pt-1">
              //                 {getFieldName(address.ccx_addresstype)]}
              //               </div>
              //               <div className="col-2">
              //                 <i
              //                   className="fas fa-pen float-end p-2"
              //                   // onClick={() => {
              //                   //   const url =
              //                   //     process.env.REACT_APP_ORG +
              //                   //     "/main.aspx?etc=10091&extraqs=formid%3d6b847ea2-0653-4dd6-a00a-34b64398884c&id=" +
              //                   //     address.ccx_contactaddressid +
              //                   //     "&pagetype=entityrecord";
              //                   //   window.open(url, "Address");
              //                   // }}
              //                 ></i>
              //               </div>
              //             </div>
              //           </Card.Header>
              //           <Card.Body className="p-2 card-body-safy">
              //             <div className="mb-2">
              //               <strong>
              //                 {address.ccx_line1 ? address.ccx_line1 + ", " : ""}
              //                 {address.ccx_city ? address.ccx_city + ", " : ""}
              //                 {address.ccx_state ? address.ccx_state + " " : ""}
              //               </strong>
              //             </div>
              //             <div className="row">
              //               <div className="col-5">
              //                 <FieldDisplay
              //                   label="Eff Date: "
              //                   value={getFieldDate(address.ccx_effectivedate)}
              //                 />
              //               </div>
              //               <div className="col-2"></div>
              //               <div className="col-5">
              //                 {address.ccx_expirationdate && (
              //                   <FieldDisplay
              //                     label="Exp Date: "
              //                     value={getFieldDate(address.ccx_expirationdate)}
              //                   />
              //                 )}
              //               </div>
              //             </div>
              //           </Card.Body>
              //         </Card>
              //       </div>
              //     );
              //   case "Allergies":
              //     const allergy = allergies.filter(
              //       (a) => a.ccx_client_allergyid === item.id
              //     )[0];
              //     return (
              //       <div
              //         className="p-2"
              //         key={`tl-${allergy.ccx_client_allergyid}`}
              //       >
              //         Allergy
              //         <Card
              //           bg="dark"
              //           className={severityBorder(getFieldName(allergy.ccx_severity))}
              //         >
              //           <Card.Header
              //             className="p-0 ps-2 bg-safy1-1"
              //             style={{
              //               color: "white",
              //             }}
              //           >
              //             <div className="row">
              //               <div className="col-10 ps-4 pt-1">
              //                 {allergy.ccx_allergystr}
              //               </div>
              //               <div className="col-2">
              //                 <i
              //                   className="fas fa-pen float-end p-2"
              //                   onClick={() => {
              //                     const url =
              //                       process.env.REACT_APP_ORG +
              //                       "/main.aspx?etc=10081&extraqs=formid%3dbbc20d14-098e-4b3c-8b11-414f87e444b0&id=" +
              //                       allergy.ccx_client_allergyid +
              //                       "&pagetype=entityrecord";
              //                     window.open(url, "Address");
              //                   }}
              //                 ></i>
              //               </div>
              //             </div>
              //           </Card.Header>
              //           <Card.Body
              //             className={
              //               allergy.ccx_expdate === undefined
              //                 ? "p-2 card-body-safy"
              //                 : "p-2 bg-warning"
              //             }
              //           >
              //             <FieldDisplay
              //               label="Type"
              //               value={allergy.ccx_allergytype}
              //             />
              //             <FieldDisplay
              //               label="Reaction"
              //               value={allergy.ccx_reactionstr}
              //             />
              //             <FieldDisplay
              //               label="Severity"
              //               value={getFieldName(allergy.ccx_severity)}
              //             />
              //             <FieldDisplay
              //               label="Effective Date"
              //               value={getFieldDate(allergy.ccx_effdate)}
              //             />
              //             {allergy.ccx_expdate && (
              //               <FieldDisplay
              //                 label="Exp Date: "
              //                 value={getFieldDate(allergy.ccx_expdate)}
              //               />
              //             )}
              //           </Card.Body>
              //         </Card>
              //       </div>
              //     );
              //   case "Care Modalities":
              //     const modality = modalities.filter(
              //       (m) => m.ccx_caremodalityid === item.id
              //     )[0];
              //     return (
              //       <div
              //         className="p-2"
              //         key={`tl-${modality.ccx_caremodalityid}`}
              //       >
              //         Care Modality
              //         <Card>
              //           <Card.Header
              //             className="p-0 ps-2 bg-safy1-1"
              //             style={{
              //               color: "white",
              //             }}
              //           >
              //             <div className="row">
              //               <div className="col-10 ps-4 pt-1">
              //                 {getFieldName(modality.ccx_caremodality)}
              //               </div>
              //               <div className="col-2">
              //                 <i
              //                   className="fas fa-pen float-end p-2"
              //                   onClick={() => {
              //                     const url =
              //                       process.env.REACT_APP_ORG +
              //                       "/main.aspx?etc=10025&extraqs=formid%3d95128619-df9e-4898-bb76-aa23823271ff&id=" +
              //                       modality.ccx_caremodalityid +
              //                       "&pagetype=entityrecord";
              //                     window.open(url, "Care Modality");
              //                   }}
              //                 ></i>
              //               </div>
              //             </div>
              //           </Card.Header>
              //           <Card.Body
              //             className={
              //               modality.ccx_enddate === undefined
              //                 ? "p-2 card-body-safy"
              //                 : "p-2 bg-warning"
              //             }
              //           >
              //             <div>
              //               <strong>
              //                 {getFieldName(modality.ccx_clientprogramid)}
              //               </strong>
              //             </div>
              //             <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-2">
              //               <div className="col-5">
              //                 <FieldDisplay
              //                   label="Start Date: "
              //                   value={getFieldDate(modality.ccx_startdate)}
              //                 />
              //               </div>
              //               <div className="col-2"></div>
              //               <div className="col-5">
              //                 {modality.ccx_enddate && (
              //                   <FieldDisplay
              //                     label="Exp Date: "
              //                     value={getFieldDate(modality.ccx_enddate)}
              //                   />
              //                 )}
              //               </div>
              //             </div>
              //           </Card.Body>
              //         </Card>
              //       </div>
              //     );
              /* #endregion */

              case "Care Team":
                const teamMember = careTeam.filter(
                  (ct) => ct.ccx_careteamid === item.id
                )[0];
                return (
                  <div className="p-2" key={`tl-${teamMember.ccx_careteamid}`}>
                    Care Team
                    <CareTeamCard teamMember={teamMember} />
                  </div>
                );

              // #region old timeline records
              //   case "Client Payors":
              //     const payor = clientPayors.filter(
              //       (p) => p.ccx_clientpayorid === item.id
              //     )[0];
              //     return (
              //       <div className="p-2" key={`tl-${payor.ccx_clientpayorid}`}>
              //         Client Payor
              //         <ClientPayorCard clientPayor={payor} />
              //       </div>
              //     );
              //   case "Client Rates":
              //     const rate = rates.filter(
              //       (r) => r.sor_fosterparentreimbursementid === item.id
              //     )[0];
              //     return (
              //       <div
              //         className="p-2"
              //         key={`tl-${rate.sor_fosterparentreimbursementid}`}
              //       >
              //         Client Rate
              //         <Card>
              //           <Card.Header
              //             className="p-0 ps-2 bg-safy1-1"
              //             style={{
              //               color: "white",
              //             }}
              //           >
              //             <div className="row">
              //               <div className="col-10 ps-4 pt-1">
              //                 {rate.sor_name}
              //               </div>
              //               <div className="col-2">
              //                 <i
              //                   className="fas fa-pen float-end p-2"
              //                   onClick={() => {
              //                     const url =
              //                       process.env.REACT_APP_ORG +
              //                       "/main.aspx?etc=10516&extraqs=formid%3d63433826-e011-4ec6-b3b9-91c89d9bdfb6&id=" +
              //                       rate.sor_fosterparentreimbursementid +
              //                       "&pagetype=entityrecord";
              //                     window.open(url, "Address");
              //                   }}
              //                 ></i>
              //               </div>
              //             </div>
              //           </Card.Header>
              //           <Card.Body
              //             className="p-2"
              //             style={{ backgroundColor: "#DDD" }}
              //           >
              //             <FieldDisplay
              //               label="Admin Rate"
              //               value={getFieldText(rate.sor_adminrate)}
              //             />
              //             <FieldDisplay
              //               label="Billing Rate"
              //               value={getFieldText(rate.sor_billingrate)}
              //             />
              //             <FieldDisplay
              //               label="Maintenance Rate"
              //               value={getFieldText(rate.sor_maintenancerate)}
              //             />
              //             <FieldDisplay
              //               label="Reason for Update"
              //               value={getFieldName(rate.sor_reasonforrateupdate)}
              //             />
              //             <FieldDisplay
              //               label="Effective Date"
              //               value={getFieldDate(rate.sor_effdate)}
              //             />
              //             <FieldDisplay
              //               label="Created On"
              //               value={getFieldDate(rate.createdon)}
              //             />
              //           </Card.Body>
              //         </Card>
              //       </div>
              //     );
              // #endregion

              case "Diagnosis":
                const diag = diagnosis.filter(
                  (d) => d.ccx_clientdiagnosisdetailid === item.id
                )[0];
                return (
                  <div
                    className="p-2"
                    key={`tl-${diag.ccx_clientdiagnosisdetailid}`}
                  >
                    Diagnosis
                    <DiagnosisCard dx={diag} />
                  </div>
                );

              // #region old timeline records
              //   case "Foster Beds":
              //     const bed = beds.filter(
              //       (d) => d.ccx_fosterchildid === item.id
              //     )[0];
              //     return (
              //       <div className="p-2" key={`tl-${bed.ccx_fosterchildid}`}>
              //         Foster Home Bed
              //         <Card>
              //           <Card.Header
              //             className="p-0 ps-2 bg-safy1-1"
              //             style={{
              //               color: "white",
              //             }}
              //           >
              //             <div className="row">
              //               <div className="col-10 ps-4 pt-1">{bed.ccx_name}</div>
              //               <div className="col-2">
              //                 <i
              //                   className="fas fa-pen float-end p-2"
              //                   onClick={() => {
              //                     const url =
              //                       process.env.REACT_APP_ORG +
              //                       "/main.aspx?etc=10223&extraqs=%3f_gridType%3d10223%26etc%3d10223%26id=" +
              //                       bed.ccx_fosterchildid +
              //                       "&pagetype=entityrecord";
              //                     window.open(url, "FosterHome");
              //                   }}
              //                 ></i>
              //               </div>
              //             </div>
              //           </Card.Header>
              //           <Card.Body
              //             className={
              //               bed.ccx_actualdischarge === undefined
              //                 ? "p-2 card-body-safy"
              //                 : "p-2 bg-warning"
              //             }
              //           >
              //             <FieldDisplay
              //               label="Service Status:"
              //               value={getFieldName(bed.ccx_servicestatuslookup)}
              //             />
              //             <FieldDisplay
              //               label="Actual Admission:"
              //               value={getFieldDate(bed.ccx_actualadmission)}
              //             />
              //             {bed.ccx_actualdischarge && (
              //               <FieldDisplay
              //                 label="Exp Date: "
              //                 value={getFieldDate(bed.ccx_actualdischarge)}
              //               />
              //             )}
              //           </Card.Body>
              //         </Card>
              //       </div>
              //     );
              // #endregion

              case "Incidents":
                const ir = incidents.filter(
                  (i) => i.ccx_incidentreportid === item.id
                )[0];
                return (
                  <div className="p-2" key={`tl-${ir.ccx_incidentreportid}`}>
                    Incident
                    <IncidentCard incident={ir} />
                  </div>
                );

              // #region old timeline records
              //   case "Medication":
              //     const medication = medications.filter(
              //       (m) => m.ccx_clientmedicationid === item.id
              //     )[0];
              //     return (
              //       <div
              //         className="p-2"
              //         key={`tl-${medication.ccx_clientmedicationid}`}
              //       >
              //         Medication
              //         <Card>
              //           <Card.Header
              //             className="p-0 ps-2 bg-safy1-1"
              //             style={{
              //               color: "white",
              //             }}
              //           >
              //             <div className="row">
              //               <div className="col-10 ps-4 pt-1">
              //                 {medication.ccx_name}
              //               </div>
              //               <div className="col-2">
              //                 <i
              //                   className="fas fa-pen float-end p-2"
              //                   onClick={() => {
              //                     const url =
              //                       process.env.REACT_APP_ORG +
              //                       "/main.aspx?etc=10065&extraqs=formid%3daf24a49f-a16f-4fac-812f-38022e863147&id=" +
              //                       medication.ccx_clientmedicationid +
              //                       "&pagetype=entityrecord";
              //                     window.open(url, "Address");
              //                   }}
              //                 ></i>
              //               </div>
              //             </div>
              //           </Card.Header>
              //           <Card.Body
              //             className={
              //               medication.ccx_stopdate === undefined
              //                 ? "p-2 card-body-safy"
              //                 : "p-2 bg-warning"
              //             }
              //           >
              //             {medication.ccx_brandname && (
              //               <FieldDisplay
              //                 label="Brand Name"
              //                 value={medication.ccx_brandname}
              //               />
              //             )}
              //             {medication.ccx_doseunit_global && (
              //               <FieldDisplay
              //                 label="Dose Unit"
              //                 value={getFieldName(medication.ccx_doseunit_global)}
              //               />
              //             )}
              //             {medication.ccx_frequency && (
              //               <FieldDisplay
              //                 label="Frequency"
              //                 value={getFieldName(medication.ccx_frequency)}
              //               />
              //             )}
              //             {medication.ccx_frequencyunit_global && (
              //               <FieldDisplay
              //                 label="Frequency Unit"
              //                 value={medication.ccx_frequencyunit_global}
              //               />
              //             )}
              //             {medication.ccx_genericid && (
              //               <FieldDisplay
              //                 label="Generic ID"
              //                 value={medication.ccx_genericid}
              //               />
              //             )}
              //             {medication.ccx_quantity && (
              //               <FieldDisplay
              //                 label="Quantity"
              //                 value={getFieldText(medication.ccx_quantity)}
              //               />
              //             )}
              //             {medication.ccx_quantityunit_global && (
              //               <FieldDisplay
              //                 label="Quantity Unit"
              //                 value={getFieldName(
              //                   medication.ccx_quantityunit_global
              //                 )}
              //               />
              //             )}
              //             {medication.ccx_route_global && (
              //               <FieldDisplay
              //                 label="Route"
              //                 value={getFieldName(medication.ccx_route_global)}
              //               />
              //             )}
              //             {medication.ccx_startdate && (
              //               <FieldDisplay
              //                 label="Start Date"
              //                 value={getFieldDate(medication.ccx_startdate)}
              //               />
              //             )}
              //             {medication.ccx_stopdate && (
              //               <FieldDisplay
              //                 label="Stop Date"
              //                 value={getFieldDate(medication.ccx_stopdate)}
              //               />
              //             )}
              //           </Card.Body>
              //         </Card>
              //       </div>
              //     );
              // #endregion

              case "Correspondence":
                const cor = correspondence.filter(
                  (c) => c.sor_soarcorrespondanceid === item.id
                )[0];
                return (
                  <div
                    className="p-2"
                    key={`tl-${cor.sor_soarcorrespondanceid}`}
                  >
                    SOAR Correspondence
                    <SOARCorrespondenceCard correspondence={cor} />
                  </div>
                );
              case "Recorded Service":
                const rs = recordedServices.filter(
                  (r) => r.ccx_recorded_serviceid === item.id
                )[0];
                return (
                  <div className="p-2" key={`tl-${rs.ccx_recorded_serviceid}`}>
                    Recorded Service
                    <RecordedServiceCard
                      service={rs}
                      notes={progressNotes.filter(
                        (note) =>
                          getFieldText(note.ccx_recordedservice) ===
                          rs.ccx_recorded_serviceid
                      )}
                      encounter={
                        rs.ccx_encounter
                          ? encounters.filter(
                              (e) =>
                                e.ccx_encounterid ===
                                getFieldText(rs.ccx_encounter)
                            )[0]
                          : null
                      }
                    />
                  </div>
                );
              case "Encounter":
                const encounter = encounters.filter(
                  (e) => e.ccx_encounterid === item.id
                )[0];
                return (
                  <div className="p-2" key={`tl-${encounter.ccx_encounterid}`}>
                    Encounter
                    <EncounterCard encounter={encounter} />
                  </div>
                );
              default:
                console.log("Default ", item.type);
                return (
                  <Card
                    bg="dark"
                    key={"time" + item.type + "-" + item.id}
                    className="mb-4"
                  >
                    <Card.Header
                      className="bg-safy1-1"
                      style={{
                        color: "white",
                      }}
                    >
                      <div className="h6">{item.type}</div>
                      <div className="h5">{item.name}</div>
                    </Card.Header>
                    <Card.Body className="card-body-safy">
                      <div className="h6">
                        Effective Date: {getFieldDate(item.effdate).toString()}
                      </div>
                      <div className="h6">
                        Expiration Date: {getFieldDate(item.expdate).toString()}
                      </div>
                      <div>Created By: {getFieldName(item.createdby)}</div>
                      <div>Created On: {getFieldDate(item.createdon)}</div>
                      <div>ID: {item.id}</div>
                    </Card.Body>
                  </Card>
                );
            }
          })}
    </>
  );
}

export default DocumentationTimeline;
